import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchSubscribers } from '../services/api'; // Use your API file

export const getSubscribers = createAsyncThunk('subscribers/getSubscribers', async () => {
    const response = await fetchSubscribers(); // Pass reviewId if available
    return response.data;
});

const subscriberSlice = createSlice({
    name: 'subscribers',
    initialState: {
        subscribers: [],  // Storing open calls here
        status: 'idle',
        error: null,
    },
    reducers: {},
    extraReducers: {
        [getSubscribers.pending]: (state) => {
            state.status = 'loading';
        },
        [getSubscribers.fulfilled]: (state, action) => {
            state.subscribers = action.payload.data;
            state.status = 'succeeded';
        },
        [getSubscribers.rejected]: (state, action) => {
            state.status = 'failed';
            state.error = action.error.message;
        },
    },
});

export default subscriberSlice.reducer;